import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { ConfirmationMessageComponent } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/components/confirmation-message/confirmation-message.component';
import { Firmantes } from '../../models/firmantes';
import { TipoDocumento } from '../../../documentos/models/tipo-documento';
import { EstadosTipoEnvio, EstadosTipoEnvioApi, TipoEnvio } from '../../models/tipo-envio';
import { TipoMail } from '../../models/tipo-mail';
import { DatosEnviosService } from '../../services/datos-envios.service';
import { FormularioEnvioService } from '../../services/formulario-envio.service';
import { FormularioValidacionesService } from '../../services/formulario-validaciones.service';
import { DocumentosModalComponent } from '../../../documentos/components/documentos-modal/documentos-modal.component';
import { DatosDocumentosService } from '../../../documentos/services/datos-documentos.service';
import { EnviosConfirmacionFirmantesModalComponent } from '../envios-confirmacion-firmantes-modal/envios-confirmacion-firmantes-modal.component';
import { ModalMessageComponent } from 'src/app/shared/components/modals/modal-message/modal-message.component';
import { TipoMensajeConfirmacion } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/models/confirmation-message-data';
import { RecuperaConfiguracionAplicacionApiService } from 'src/app/pages/configuracion/configuracion-rlt/services/recupera-configuracion-aplicacion-api.service';
import { SpinnerModalSqpComponent } from 'src/app/shared/components/sqp-components/sqpModales/spinner-modal-sqp/spinner-modal-sqp.component';

@Component({
  selector: 'app-configura-envio-page',
  templateUrl: './configura-envio-page.component.html',
  styleUrls: ['./configura-envio-page.component.css']
})
export class ConfiguraEnvioPageComponent implements OnInit {

  tituloPagina: string = '';
  icono2: string = '';
  tipoMailsString: string[] = [];
  tiposMails2: TipoMail[] = [];
  objetoEnvio!: TipoEnvio;
  envio!: TipoEnvio;
  envios: TipoEnvio[] = [];
  mostrarForm: boolean = false;
  isMismoNombre: boolean = false;
  // firmantes: Firmantes[] = []
  firmantesInit: Firmantes[] = [
    {
      orden:1,
      tipoFirmante:{
        codigo:"100",
        desc:"Firmante principal"
        },
      tipoDestinatario:{
        codigo:"",
        desc:""
      },
      tipoBusqueda:{
        codigo:"",
        desc:""
      }
    }
  ]
  documentos: TipoDocumento[] = [];
  documentosEnvio: TipoDocumento[] = [];
  estadoCambiado: boolean = false;
  recordatorios: number[]=[null];
  hayCopiaBasica: number = 0;
  errorValidador: boolean = false;
  errorValidadorCampos: string[] = [];
  arrayMismoNum: boolean[] = [];
  arrayMismoCodigo: boolean[] = [];
  smsActivado:boolean = false;
  securizadoSMSActivado:boolean = false;
  modoEnvioSeleccionado:string;
  moduloSmsActivo:boolean = false;
  moduloXmlActivo:boolean = false;
  onlyAvisoXml:boolean = false;
  errorNombre: boolean = false;
  cargando: boolean = false;

  constructor(private datosEnvioService: DatosEnviosService,
              private _snackBar: MatSnackBar,
              public formularioEnvioService: FormularioEnvioService,
              public formularioValidacionesService: FormularioValidacionesService,
              private dialog: MatDialog,
              public dialogRef: MatDialogRef<any>,
              private activeRoute: ActivatedRoute,
              private datosDocumentosService: DatosDocumentosService,
              private router: Router,
              private recuperaConfiguracionAplicacionService: RecuperaConfiguracionAplicacionApiService) {}

  async ngOnInit() {
    this.cargando = true;
    try {
      // Execute all async operations in parallel
      const [envioResult, modulosActivosResult] = await Promise.all([
        this.getEnvio(),
        this.recuperaConfiguracionAplicacionService.getModulosActivos().pipe(take(1)).toPromise().catch(error => {
          console.log(error);
          return { ModuloSmsActivo: false, ModuloEnvioXmlActivo: false };
        })
      ]);

      this.getTitulo();
      await this.formularioEnvioService.resetFormularioEnvio();
      await this.formularioEnvioService.recuperaFormularioTemporal(this.envio);
      // this.firmantes = this.formularioEnvioService.formularioEnvio.controls['firmantes'].value;
      this.documentosEnvio = this.formularioEnvioService.formularioEnvio.controls['tiposDocumento'].value;
      this.formularioEnvioService.formEnvioTemporal = new FormGroup({});
      this.checkActivado();
      this.checkSiSecurizadoSMS();
      this.checkSiXml();
      this.formularioEnvioService.subscribeToEnvioXmlValue();
      this.subscribeToNombreChanges();
      this.montarListaTipoMail();

      if (modulosActivosResult) {
        this.moduloSmsActivo = modulosActivosResult.ModuloSmsActivo;
        this.moduloXmlActivo = modulosActivosResult.ModuloEnvioXmlActivo;

        if(this.moduloSmsActivo){
          this.formularioEnvioService.habilitarModoEnvio();
          this.formularioEnvioService.subscribeToEnvioMailValue();
          this.formularioEnvioService.subscribeToEnvioSMSValue();
        }else{
          this.ordenTelefonoSMS.disable();
        }
      }
    } catch (error) {
      console.error('Error in ngOnInit:', error);
    } finally {
      this.cargando = false;
    }
  }

  getTitulo(){
    if(this.envio.idTipoEnvio == ""){
      this.tituloPagina = "Nueva configuración de dosier";
      this.icono2 = "#icon-plus";
    }else{
      this.tituloPagina = "Editar dosier configurado";
      this.icono2 = "";
    }
  }

  getTipoDocumentos(): Promise<void>{
    // Lazy-load and cache: only call API if we don't have documentos yet
    // if (this.documentos && this.documentos.length > 0) {
    //   return Promise.resolve();
    // }

    return new Promise((resolve) => {
      this.datosDocumentosService.getTipoDocumentos([],0).subscribe(
        next => {
          this.documentos = next;
          resolve();
        },
        error => {
          if(error.status!==401) {
            this._snackBar.open(error.message, 'Cerrar',{duration: 4000});
          }
          resolve(); // resolve even on error to avoid hanging callers
        }
      );
    });
  }

//  async getTipoEnvios(){
//   // if(this.datosEnvioService.enviosFiltrados){
//   //   this.envios = this.datosEnvioService.enviosFiltrados
//   // }else{
//     await this.datosEnvioService.getTipoEnvios([],0)
//      this.envios = this.datosEnvioService.enviosFiltrados
//   // }

//   }

  //Getters para el formulario
  get nombre(){ return this.formularioEnvioService.formularioEnvio.get('nombre') }
  get subject(){ return this.formularioEnvioService.formularioEnvio.get('subject') }
  get numeroAdjuntos(){ return this.formularioEnvioService.formularioEnvio.get('numeroAdjuntos') }
  get tiposDocumento(){ return this.formularioEnvioService.formularioEnvio.get('tiposDocumento')}
  get recordatorio(){ return this.formularioEnvioService.formularioEnvio.get('recordatorio')}
  get reminders_String(){ return this.formularioEnvioService.formularioEnvio.get('reminders_String')}
  get envioSMS(){ return this.formularioEnvioService.formularioEnvio.get('envioSMS')}
  get securizadoSMS(){ return this.formularioEnvioService.formularioEnvio.get('securizadoSMS')}
  get body(){ return this.formularioEnvioService.formularioEnvio.get('body')}
  get bodySMS(){ return this.formularioEnvioService.formularioEnvio.get('bodySMS')}
  get envioMail(){ return this.formularioEnvioService.formularioEnvio.get('envioMail')}
  get ordenMail(){ return this.formularioEnvioService.formularioEnvio.get('ordenMail')}
  get ordenTelefonoSMS(){ return this.formularioEnvioService.formularioEnvio.get('ordenTelefonoSMS')}
  get ordenTelefonoOTP(){ return this.formularioEnvioService.formularioEnvio.get('ordenTelefonoOTP')}
  get envioXml(){ return this.formularioEnvioService.formularioEnvio.get('envioXml')}
  get nombreComienzaLibra(){ return this.formularioEnvioService.formularioEnvio.get('nombreComienzaLibra')}


  changeValue(e: any,value:any) {
    value?.setValue(e.target.value, {
      onlySelf: true,
    });
  }

  comprobarNumFirmantes(){
    this.formularioEnvioService.getValorFinalCanalEnvioActivo();
    if(!this.envioMail.value && !this.envioSMS.value){
      const dialogRef = this.dialog.open(ModalMessageComponent, {
        data: {
          titulo: 'Selecciona un tipo de envío disponible',
          mensaje: 'Debes seleccionar al menos un tipo de envío disponible. Haz la selección manteniendo siempre uno de ellos chequeado.',
          textoBoton: 'Aceptar',
          alert: true
        }
      });
      return
    }
    this.formularioValidacionesService.checkSiEnvioXml();
    this.objetoEnvio = this.formularioEnvioService.formularioEnvio.value;
    this.arrayMismoNum = [];
    this.arrayMismoCodigo = [];
    let hayDocs: boolean = true;
    if(this.objetoEnvio.tiposDocumento.length == 0){
      hayDocs = false;
    }else{
      this.objetoEnvio.tiposDocumento.forEach(x=>{
        this.comprobarErroresValidador(x);
        if(x.fusionable == false){
          if(x.firmantesNif == null){
            this.arrayMismoNum.push(false);
          }else
          if(x.firmantesNif.length == this.objetoEnvio.firmantes.length){
            this.arrayMismoNum.push(true);
            x.firmantesNif.forEach(y=>{
              let index = this.objetoEnvio.firmantes.findIndex(z=>z.tipoFirmante.codigo==y.tipoFirmante.codigo)
              if(index>-1){
                this.arrayMismoCodigo.push(true)
              }else this.arrayMismoCodigo.push(false)
            })
          }else{ this.arrayMismoNum.push(false) }
        }
      })
    }
    this.formularioValidacionesService.addValidatorsFirmantesArrayForm();
    this.objetoEnvio.ordenMail = this.formularioEnvioService.buscarModoEnvioDescripcion('ordenMail');
    this.objetoEnvio.ordenTelefonoSMS = this.formularioEnvioService.buscarModoEnvioDescripcion('ordenTelefonoSMS');
    this.objetoEnvio.ordenTelefonoOTP = this.formularioEnvioService.buscarModoEnvioDescripcion('ordenTelefonoOTP');
    this.formularioValidacionesService.validacionAvisos();
    if(this.formularioEnvioService.formularioEnvio.invalid){
      this.formularioEnvioService.formularioEnvio.markAllAsTouched();
    }

    if(hayDocs==false ||
       this.arrayMismoNum.includes(false) ||
       this.arrayMismoCodigo.includes(false) ||
       this.formularioValidacionesService.validacionAvisos()==true ||
       this.formularioEnvioService.formularioEnvio.invalid ||
       this.errorValidador ||
       this.errorValidadorCampos.length>0 ||
       this.formularioValidacionesService.avisoXml){

        this.onlyAvisoXml = (
          hayDocs &&
          !this.arrayMismoNum.includes(false) &&
          !this.arrayMismoCodigo.includes(false) &&
          !this.formularioValidacionesService.validacionAvisos() &&
          this.formularioEnvioService.formularioEnvio.valid &&
          !this.errorValidador &&
          this.errorValidadorCampos.length === 0 &&
          this.formularioValidacionesService.avisoXml
      );

      const textoConfirmacion = this.onlyAvisoXml ? 'Guardar' : 'Guardar como incompleto';

       this.abrirModalErrores(textoConfirmacion);
    }else{
      this.objetoEnvio.estado = EstadosTipoEnvioApi.completo
      this.objetoEnvio.activo = this.activado;
      if(this.objetoEnvio.activo == false) this.abrirModalConfirmacionActivado();
      else this.guardaTipoDosierRequest();
    }
    this.errorValidador=false;
    this.errorValidadorCampos=[];
  }

  abrirModalErrores(textoConfirmacion:string){
    let dataEnvio = {
      infoEnvio: this.objetoEnvio,
      isValidadorError: this.errorValidador,
      isValidadorErrorCampos: this.errorValidadorCampos,
      diferenteNumeroFirmantes: this.arrayMismoNum.includes(false),
      diferenteCodigoFirmantes: this.arrayMismoCodigo.includes(false)
    }
    const dialogRef = this.dialog.open(EnviosConfirmacionFirmantesModalComponent, {
      data: {
        extraInfo: dataEnvio,
        tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
        textoConfirmacion: textoConfirmacion,
        iconoConfirmacion: 'hs-send',
        textoCancelar: 'cancelar'
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result === 'OK'){
        if(!this.onlyAvisoXml){
          this.objetoEnvio.estado = EstadosTipoEnvioApi.incompleto
          this.objetoEnvio.activo = false;
        }else{
          this.objetoEnvio.estado = EstadosTipoEnvioApi.completo
          this.objetoEnvio.activo = true;
        }

        this.guardaTipoDosierRequest();
      }
    });
  }

  anadirNuevoDoc(){
    this.formularioEnvioService.addFormularioTemporal();
    this.router.navigate(['/panel/nueva-configuracion-documento']);
  }

  abrirModalConfirmacionActivado(){
    const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
      data: {
        extraInfo:{boton: 'Guardar desactivado'},
        tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
        icono: 'icon-save',
        soloMensaje: '¿Desea guardar la configuración del dosier como activo?',
        textoConfirmacion: 'Guardar activo',
        iconoConfirmacion: 'icon-save',
        textoCancelar: 'cancelar'
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result === 'OK') {
        this.objetoEnvio.activo = true;
        this.guardaTipoDosierRequest();
      }else if(result === 'desactivar') {
        this.objetoEnvio.activo = false;
        this.guardaTipoDosierRequest();
      }
    });
  }

  confirmacionGuardadoOk(){
    const dialogRef = this.dialog.open(ModalMessageComponent, {
      data: {
        mensaje: 'Configuración de dosier guardada correctamente',
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.datosEnvioService.refresh = true;
      this.router.navigate(['/panel/dosieres-configurados'], {
        state: { configuracionEnvio: true }
      });
    });
  }

  //cogemos la data del envio a través del parámetro de la ruta y se lo mandamos como id al formulario de nueva configuración de envío
  async getEnvio(){
    const id = this.activeRoute.snapshot.params['idV3TipoEnvio'];
    // const id = this.activeRoute.snapshot.params['idTipoEnvio'];
    if(id == "0"){
      let nuevoEnvio = {} as TipoEnvio;
      nuevoEnvio.idTipoEnvio = "";
      nuevoEnvio.reminders_String = [];
      // nuevoEnvio.expire_time = null;
      nuevoEnvio.numeroAdjuntos = null;
      nuevoEnvio.documentosEnvioProgramado = null;
      nuevoEnvio.firmantes = this.firmantesInit;
      this.envio = nuevoEnvio;
      // this.firmantes = this.firmantesInit;
    }else{
      await this.datosEnvioService.getTipoEnvio(id).then(
        (resp:any) => {
          this.envio = resp;
          // this.firmantes = this.envio.firmantes
          this.documentosEnvio = this.envio.tiposDocumento
        },
        error => {
          if(error.status!==401) this._snackBar.open(error.message, 'Cerrar',{duration: 4000});
          throw error;
        }
      )
    }
  }

  async anadirDocExistente(){
    // Ensure documentos are loaded only when needed
    const dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
    await this.getTipoDocumentos();
    dialogRefSpinner.close();
    this.objetoEnvio = this.formularioEnvioService.formularioEnvio.value;
    this.objetoEnvio.ordenMail = this.formularioEnvioService.buscarModoEnvioDescripcion('ordenMail');
    this.objetoEnvio.ordenTelefonoSMS = this.formularioEnvioService.buscarModoEnvioDescripcion('ordenTelefonoSMS');
    this.objetoEnvio.ordenTelefonoOTP = this.formularioEnvioService.buscarModoEnvioDescripcion('ordenTelefonoOTP');
    //eliminamos estado si lo lleva porqué el formulario no lo tiene. Se le añade antes de guardar el envío. Se tiene que revisar
    this.objetoEnvio.estado;
    const dialogRef = this.dialog.open(DocumentosModalComponent, {
      data: {
        documentos:this.documentos,
        objetoEnvio: this.objetoEnvio,
        origenModal: 'anadir-doc-existente'
      },
      panelClass: 'modal-class-detalle',
      position: { right: '0'},
      autoFocus: 'dialog'
    });

    dialogRef.afterClosed().subscribe(result=>{
      if(result === 'OK'){
        this.refresh();
        this.formularioEnvioService.habilitarModoEnvio();
      }
    })
  }

  refresh(){
    this.hayCopiaBasica = 0;
    this.documentosEnvio = this.formularioEnvioService.tiposDocumento.value
    this.documentosEnvio.forEach((x: TipoDocumento)=> x.esCopiaBasica ? this.hayCopiaBasica++ : this.hayCopiaBasica)
  }

  guardaTipoDosierRequest(){
    if(this.formularioValidacionesService.avisoXml) this.objetoEnvio.nombreComienzaLibra=''; //borramos el nombreComienzaLibra si envioXml false;
    delete this.objetoEnvio.estado;
    //añadimos {{url}} tag al bodySMS si no existe en el envío por SMS
    if (this.objetoEnvio.envioSMS && !this.objetoEnvio.bodySMS?.includes('{{url}}')) {
      const existingText = this.objetoEnvio.bodySMS || '';
      this.objetoEnvio.bodySMS = `${existingText} {{url}}`;
    }
    this.objetoEnvio.nombre = this.objetoEnvio.nombre.trim();

    this.datosEnvioService.guardaEnvio(this.objetoEnvio).subscribe(
      ok => {
        this.confirmacionGuardadoOk();
      },
      error => {
        console.error("error", error);
      },
      () => {
        // this.datosEnvioService.refresh = true;
        // this.router.navigate(['/panel/dosieres-configurados'], {
        //   state: { configuracionEnvio: true }
        // });
      }
    );
  }

  guardaBorrador(){
    this.formularioEnvioService.getValorFinalCanalEnvioActivo();
    this.formularioEnvioService.formularioEnvio.controls['nombre'].markAsTouched();
    if(this.formularioValidacionesService.isCampoValido('nombre')){
      this.errorNombre = true;
      this._snackBar.open('El nombre del dosier es obligatorio, también para guardar como borrador.', 'Cerrar', {duration: 5000});
      return;
    }else{
      this.errorNombre = false;
    }

    this.objetoEnvio = this.formularioEnvioService.formularioEnvio.value;
    this.objetoEnvio.ordenMail = this.formularioEnvioService.buscarModoEnvioDescripcion('ordenMail');
    this.objetoEnvio.ordenTelefonoSMS = this.formularioEnvioService.buscarModoEnvioDescripcion('ordenTelefonoSMS');
    this.objetoEnvio.ordenTelefonoOTP = this.formularioEnvioService.buscarModoEnvioDescripcion('ordenTelefonoOTP');
    if(this.objetoEnvio.estado) delete this.objetoEnvio.estado;

    const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
      data: {
        tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
        icono: 'icon-save',
        soloMensaje: '¿Desea guardar la configuración del dosier como borrador?',
        textoConfirmacion: 'Guardar borrador',
        iconoConfirmacion: 'icon-save',
        textoCancelar: 'cancelar'
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result === 'OK') {
        this.datosEnvioService.guardaEnvio(this.objetoEnvio).subscribe(
          ok => {
            this.confirmacionGuardadoBorradorOk();
          },
          error => {
            console.error("error", error);
          }
        );
      }
    })
  }

  confirmacionGuardadoBorradorOk(){
    const dialogRef = this.dialog.open(ModalMessageComponent, {
      data: {
        mensaje: 'Borrador guardado correctamente',
      },
    });

    dialogRef.afterClosed().subscribe(result => {

      this.datosEnvioService.refresh = true;
      this.router.navigate(['/panel/dosieres-configurados']);
    });
  }

  activado: boolean = false;
  toggleActivado(event:any){
    this.activado = event;
  }

  checkActivado(){
    if(this.envio.estado == EstadosTipoEnvio.completo || this.envio.activo == true) this.activado = true;
    else this.activado = false;
  }

  agregarAviso(){
    if(this.recordatorio.value == true){
      if(this.formularioEnvioService.recordatorios.includes(null)) this._snackBar.open('Se tiene que completar el campo, antes de agregar otro.', 'Cerrar', {duration: 3000})
      else if(!this.formularioEnvioService.disableRecordatorio) this.formularioEnvioService.recordatorios.push(null)
      else this._snackBar.open('Se tiene que marcar "Avisos de firma" para poder agregar un aviso', 'Cerrar', {duration: 3000})
      this.guardarAForm();
    }
  }

  clickAvisoFirma(){ //añadimos un aviso si no hay ninguno al clicar la casilla
    if(this.recordatorio.value == false && this.formularioEnvioService.recordatorios.length == 0) this.formularioEnvioService.recordatorios.push(1)
  }

  eliminarAviso(event:number){
    this.formularioEnvioService.recordatorios.splice(event,1)
    this.guardarAForm();
    if(this.formularioEnvioService.recordatorios.length == 0) this.formularioEnvioService.formularioEnvio.controls['recordatorio'].setValue(false);
  }

  updateAviso(event: any){
    this.formularioEnvioService.recordatorios[event.index] = event.valor;
    this.guardarAForm();
  }

  guardarAForm(){
    let numRecordatorios = this.formularioEnvioService.recordatorios.toString()
    this.formularioEnvioService.formularioEnvio.controls['reminders_String'].setValue(numRecordatorios)
  }

  comprobarErroresValidador(tipoDoc: TipoDocumento){
    this.objetoEnvio.firmantes.forEach(x=>{
      tipoDoc.firmantesNif.forEach((y:any)=>{
        if(x.tipoFirmante.codigo==y.tipoFirmante.codigo &&
           ((x.tipoDestinatario.codigo!=="validator" && y.tipoDestinatario.codigo=="validator") ||
            (x.tipoDestinatario.codigo=="validator" && y.tipoDestinatario.codigo!=="validator") )) {
          this.errorValidador=true;
        }
        else if((y.tipoDestinatario.codigo=="validator" && y.formularios.length>0) ||
                (y.tipoDestinatario.codigo=="validator" && y.camposEditables.length>0)) {
                  if(!this.errorValidadorCampos.includes(tipoDoc.nombre)) this.errorValidadorCampos.push(tipoDoc.nombre);
                }
      })
    })
  }

  checkSiSecurizadoSMS(){
    if(!this.securizadoSMS.value) this.ordenTelefonoOTP.disable();
    else this.ordenTelefonoOTP.enable();
  }

  enableEnvioSecurizadoSMS(event: boolean){
    this.securizadoSMS.setValue(event)
    if(event){
      this.ordenTelefonoOTP.enable();
    }else{
      this.ordenTelefonoOTP.setValue('');
      this.ordenTelefonoOTP.disable();
    }
  }

  get characterCount(){
    return this.bodySMS.value?.length || 0;
  }

  getModulosActivos(){
    this.recuperaConfiguracionAplicacionService.getModulosActivos().subscribe(
      ok =>{
        this.moduloSmsActivo = ok.ModuloSmsActivo;
        this.moduloXmlActivo = ok.ModuloEnvioXmlActivo;

        if(this.moduloSmsActivo){
          this.formularioEnvioService.habilitarModoEnvio();
          this.formularioEnvioService.subscribeToEnvioMailValue();
          this.formularioEnvioService.subscribeToEnvioSMSValue();
        }else{
          this.ordenTelefonoSMS.disable();
        }
      },
      error => {
        console.log(error);
        this.moduloSmsActivo = false;
        this.moduloXmlActivo = false;
      }
    );
  }

  tooltipVisible: boolean = false;

  showTooltip(){
    this.tooltipVisible = true;
  }

  hideTooltip(){
    this.tooltipVisible = false;
  }

  checkSiXml(){
    if(!this.envioXml.value) this.nombreComienzaLibra.disable();
    else this.nombreComienzaLibra.enable();
  }

  subscribeToNombreChanges(){
    this.nombre.valueChanges.subscribe(value => {
      if (this.errorNombre && !this.formularioValidacionesService.isCampoValido('nombre')) {
          this.errorNombre = false;
      }
    })
  }

  getCheckboxValue(event:any, tipo:string){
    switch(tipo){
      case 'MAIL':
        if(!this.envioMail.value){
          this.subject.setValue('');
          this.body.setValue('');
        }
      break;
      case 'SMS':
        if(!this.envioSMS.value) this.bodySMS.setValue('');
      break;
    }
  }

  montarListaTipoMail(){
    this.tipoMailsString = this.formularioEnvioService.tiposMails.map(x => x.desc)
  }

  onMailSeleccionado(event: any, tipo: string){
    const descripcionSeleccionada = typeof event === 'string' ? event : event?.desc;
    if (!descripcionSeleccionada) return;

    const codigo = this.formularioEnvioService.tiposMails.find(x => x.desc == descripcionSeleccionada)?.codigo;
    if (codigo === undefined || codigo === null || codigo === '') return;

    switch(tipo){
      case 'email':
        this.ordenMail.setValue(codigo);
      break;
      case 'sms':
        this.ordenTelefonoSMS.setValue(codigo);
      break;
      case 'otp':
        this.ordenTelefonoOTP.setValue(codigo);
      break;
    }

  }
}
